module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.system-parameters')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('data-table', {
    attrs: {
      "model": "system-parameters",
      "columns": ['id', 'value']
    },
    on: {
      "row-click": _vm.rowClick
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [(_vm.selected) ? _c('data-form', {
    attrs: {
      "entity": _vm.selected,
      "model": "system-parameters",
      "fields": _vm.fields,
      "cancel": false
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d09363e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system-parameter/SystemParameterList.vue
// module id = 1024
// module chunks = 2